/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgHandDown = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M16.038 2C19.325 2 22 4.69 22 7.998V10c0 1.654-1.338 3-2.982 3-.348 0-.683-.06-.994-.171V14c0 1.654-1.338 3-2.982 3-.348 0-.683-.06-.994-.171V19c0 1.654-1.338 3-2.982 3-1.644 0-2.982-1.346-2.982-3v-4.586l-.788.793a3.093 3.093 0 0 1-4.387 0C2.322 14.618 2 13.834 2 13s.322-1.618.909-2.207l1.49-1.5 2.676-3.146A11.765 11.765 0 0 1 16.038 2zm-3.978 9h1.988v3c0 .552.445 1 .994 1s.994-.448.994-1V9h1.988v1c0 .552.445 1 .994 1a.997.997 0 0 0 .994-1V7.998C20.012 5.794 18.23 4 16.038 4a9.783 9.783 0 0 0-7.453 3.448L5.857 10.65l-1.543 1.557c-.21.212-.326.493-.326.793a1.116 1.116 0 0 0 1.902.793l2.485-2.5a.985.985 0 0 1 1.084-.217 1 1 0 0 1 .613.924v7c0 .552.445 1 .994 1s.994-.448.994-1z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgHandDown as HandDown };
